import { EmploymentTemplate } from 'views/components/templates/establishes';
import { useEmployment } from './hooks';
import { Gauge, GaugeSP, getGaugeValue } from 'views/components/atoms/gauge';
import { useLocation } from 'react-router-dom';

export const Employment = () => {
  const tempProps = useEmployment();
  const location = useLocation();

  return (
    <form className="establishFormSP" onSubmit={tempProps.formik.handleSubmit}>
      <GaugeSP currentPage={getGaugeValue(location.pathname)} />
      <EmploymentTemplate {...tempProps} />
    </form>
  );
};
